import LangAdmin from './en-us/admin';
import LangBilling from './en-us/billing';
import LangCompany from './en-us/company';
import LangComponent from './en-us/component';
import LangDocument from './en-us/document';
import LangDownloadCenter from './en-us/download-center';
import LangErrCodeMsg from './en-us/err-msg';
import LangGameContent from './en-us/game-content';
import LangHomeNav from './en-us/home-nav';
import LangInvoice from './en-us/invoice';
import LangMessageCenter from './en-us/message-center';
import NoticeInvoice from './en-us/notice';
import LangOther from './en-us/other';
import LangPrice from './en-us/price';
import LangRbac from './en-us/rbac';
import LangStudio from './en-us/studio';
import LangUser from './en-us/user';

const common = {
  common_header_home: 'Home',
  owner_email: 'Owner (email)',
  created_time: 'Created Time (UTC)',
  create_time: 'Creation Time (UTC)',
  create_time_local: 'Creation Time',
  creator_email: 'Creator (Email)',
  code_name: 'Code Name',
  last_modify_time: 'LastModifyTime (UTC)',
  last_modify_time_local: 'Last Modify Time',
  modify_time: 'Modify Time (UTC)',
  modify_time_local: 'Modify Time',
  update_time: 'Update Time (UTC)',
  update_time_local: 'Update Time',
  list: 'List',
  new: 'New',
  operate: 'Operate',
  edit: 'Edit',
  view: 'View',
  create: 'Create',
  delete: 'Delete',
  submit: 'Submit',
  cancel: 'Cancel',
  confirm: 'Confirm',
  confirm_to: 'Confirm',
  close: 'Close',
  open: 'Open',
  refresh: 'Refresh',
  opened: 'Opened',
  closed: 'Closed',
  remove: 'Remove',
  save: 'Save',
  yes: 'Yes',
  no: 'No',
  dev_type: 'DEV',
  live_type: 'LIVE',
  contact_us: 'contact us',
  clear_all: 'Clear All',
  all: 'All',
  owner_type: 'Owner',
  admin_type: 'Admin',
  id: 'id',
  sort: 'Sort',
  env: 'Env',
  region: 'Main Site',
  create_by: 'Created By',
  status: 'Status',
  game: 'game',
  title: 'Title',
  // name_lowercase:'name',
  name_uppercase: 'Name',
  member_name: 'Name',
  environment: 'Environment',
  environments: 'Environments',
  password: 'Password',
  email_uppercase: 'Email',
  email_lowercase: 'email',
  please_enter: 'Please Enter',
  please_enter_field: 'Please enter {{name}}',
  please_enter_email: 'Please enter email',
  please_enter_password: 'Please enter password',
  common_status_step_pending: 'Pending',
  common_status_step_approved: 'Approved',
  common_status_step_rejected: 'Rejected',
  common_status_step_active: 'Active',
  common_status_step_expired: 'Expired',
  common_status_step_partly: 'Partly Visible',
  common_disable: 'Disable',
  common_enable: 'Enable',
  successfully: 'Successfully.',
  success: 'Success.',
  save_success: 'Save successfully.',
  save_failed: 'Save failed.',
  failed: 'Failed.',
  failed_submit: 'Failed to submit.',
  select_items: 'Selected {{count}} items, ',
  total_items: 'Total {{total}} items',
  total_with_checked_items:
    'Total {{total}} items, {{count}} have been selected',
  can_not_empty: 'Can not be empty',
  i_know: 'I know',
  sorry_404_desc: 'Sorry, the page you visited does not exist.',
  back: 'Back',
  select_all_tag: 'ALL',
  site_switch_cn: 'Go to Chinese Site',
  site_switch_en: 'Go to International Site',
  site_switch_woa: 'Go to Woa Site',
  site_switch_pre: 'Go to Pre-production Site',
  site_switch_cn_desc:
    'You are about to go to the InGame Chinese Site. Do you want to continue?',
  site_switch_en_desc:
    'You are about to go to the InGame International Site. Do you want to continue?',
  site_switch_woa_desc:
    'You are about to go to the InGame Woa Site. Do you want to continue?',
  site_switch_pre_desc:
    'You are about to go to the InGame Pre-production Site. Do you want to continue?',
  ...LangStudio,
  ...LangAdmin,
  ...LangComponent,
  ...LangDocument,
  ...LangGameContent,
  ...LangUser,
  ...LangMessageCenter,
  ...LangErrCodeMsg,
  ...LangOther,
  ...LangDownloadCenter,
  ...LangHomeNav,
  ...LangPrice,
  ...LangRbac,
  ...LangBilling,
  ...LangCompany,
  ...LangInvoice,
  ...NoticeInvoice,
};

// eslint-disable-next-line no-restricted-syntax
export default Object.assign(common);
